import { render } from "./ReceiptPrinters.vue?vue&type=template&id=a2a49a68&ts=true"
import script from "./ReceiptPrinters.vue?vue&type=script&lang=ts"
export * from "./ReceiptPrinters.vue?vue&type=script&lang=ts"

import exportComponent from "/home/muhammadibrahim/Myserver/medix_envato_v4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__